function prefersReduce() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function bootReveal(root) {
  const nodes = [...root.querySelectorAll('[data-reveal]')];
  if (!nodes.length) return () => {};
  if (prefersReduce()) {
    nodes.forEach((node) => node.classList.add('is-in'));
    return () => {};
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }
  );
  nodes.forEach((node) => io.observe(node));
  return () => io.disconnect();
}

function bootThread(root) {
  if (prefersReduce()) {
    root.classList.add('is-threaded');
    return () => {};
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        root.classList.add('is-threaded');
        io.unobserve(root);
      });
    },
    { threshold: 0.28 }
  );
  io.observe(root);
  return () => io.disconnect();
}

function bootProcess(root) {
  if (!root || root.dataset.booted === '1') return;
  root.dataset.booted = '1';
  const cleanups = [bootReveal(root), bootThread(root)];
  root._artinkProcessCleanup = () => {
    cleanups.forEach((fn) => fn && fn());
    root.dataset.booted = '0';
  };
}

function initAll() {
  document.querySelectorAll('[data-artink-process]').forEach(bootProcess);
}

initAll();
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-artink-process]').forEach(bootProcess);
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-artink-process]').forEach((root) => {
    root._artinkProcessCleanup?.();
  });
});
